import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_FILTERS,
  Filters,
} from './filters.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getFiltersList(): AxiosPromise<ServerResponse<Filters>> {
  return http.get(`${API_PATH_FILTERS}`);
}

export function getFilters(
  id: string,
): AxiosPromise<ServerResponse<Filters>> {
  return http.get(`${API_PATH_FILTERS}/${id}`);
}

export function createFilters(
  deliveryFunctionId: string,
  body: WithAuditDetails<Filters>,
): AxiosPromise<ServerResponse<Filters>> {
  return http.post(`${API_PATH_FILTERS}`, body);
}

export function updateFilters(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<Filters>,
): AxiosPromise<ServerResponse<Filters>> {
  return http.put(`${API_PATH_FILTERS}/${deliveryFunctionId}/${id}`, body);
}

export function deleteFilters(
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<Filters>> {
  return http.delete(`${API_PATH_FILTERS}/${id}`, { data: body.auditDetails });
}
